/**
 * @param {DOMTokenList} domTokenList
 * @param {string} modifier
 * @return {string}
 */
function getFullModifierClassName(domTokenList, modifier) {
  if (domTokenList.length === 0) {
    return '';
  }
  return domTokenList.item(0) + '--' + modifier;
}

DOMTokenList.prototype.addModifier = function (modifier) {
  const fullModifierClassName = getFullModifierClassName(this, modifier);
  if (!fullModifierClassName) {
    return;
  }
  this.add(fullModifierClassName);
};

DOMTokenList.prototype.removeModifier = function (modifier) {
  const fullModifierClassName = getFullModifierClassName(this, modifier);
  if (!fullModifierClassName) {
    return;
  }
  this.remove(fullModifierClassName);
};

DOMTokenList.prototype.hasModifier = function (modifier) {
  const fullModifierClassName = getFullModifierClassName(this, modifier);
  if (!fullModifierClassName) {
    return false;
  }
  return this.contains(fullModifierClassName);
};
